import * as SBSections from './sections';
import * as SBTemplates from './templates';

// Templates
const templateComponents = {
  projectExampleTemplate: SBTemplates.SBProjectExampleTemplate,
};

// Sections
const sectionComponents = {
  projectExampleSection: SBSections.SBProjectExampleSection,
};

export const projectComponents = { ...templateComponents, ...sectionComponents };
